import {Autocomplete, styled, TextField} from '@mui/material'

const AutocomplateInput = ({
    name,
    label,
    placeholder,
    options,
    InputProps,
    getOptionLabel,
    filterFunc,
    onOpen,
    onChange,
}) => {
    return (
        <Autocomplete
            freeSolo
            disableClearable
            name={name}
            label={label}
            options={options}
            getOptionLabel={getOptionLabel}
            placeholder={placeholder}
            filterOptions={filterFunc}
            onOpen={onOpen}
            onChange={onChange}
            slotProps={{
                popper: {
                    sx: {
                        direction: 'rtl',
                    },
                },
                clearIndicator: {
                    sx: {
                        display: 'none',
                    },
                },
            }}
            renderInput={(params) => (
                <Input
                    {...params}
                    variant="filled"
                    placeholder={placeholder}
                    InputProps={{
                        ...params.InputProps,
                        ...InputProps,
                        type: 'search',
                    }}
                    InputLabelProps={{
                        sx: {
                            color: '#84ac83',
                        },
                    }}
                />
            )}
        />
    )
}

export default AutocomplateInput

const Input = styled(TextField)`
    & ::placeholder {
        color: #fff;
    }
`
